/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { PRODUCT_FRAGMENT } from '@/pdp/api/graphql/ProductFragment.graphql';

export const REFINE_PRODUCT_QUERY = `
query REFINE_PRODUCT_QUERY(
    $optionIds: [String!]!
    $sku: String!
) {
    # Refined Product
    refineProduct(
        optionIds: $optionIds 
        sku: $sku
    ) {
        ...PRODUCT_FRAGMENT
    }

    # Parent Product
    products(skus: [$sku]) {
        ...PRODUCT_FRAGMENT
    }

    # %extendedPlaceholder%
}

${PRODUCT_FRAGMENT}
`;
